import styled, { css } from 'styled-components';

const thumbStyle = css`
  -webkit-appearance: none;
  border: 1px solid #000000;
  height: 18px;
  width: 18px;
  border-radius: 10px;
  background: #156EAC;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
`;

const trackStyle = css`
  width: 100%;
  height: 7px;
  cursor: pointer;
  background: darkgray;
  border-radius: 10px;
  border: 0.2px solid #010101;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
`

// input type=range consistently styled
export const Slider = styled.input.attrs(props => ({
  type: 'range',
  min: props.min || 0,
  max: props.max || 100,
  step: props.step || 1
})) `
  // ------------------------------------ remove browser style -------------------------------------                         

  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  //width: 100%; /* Specific width is required for Firefox. */
  height: 25px;
  background: transparent; /* Otherwise white in Chrome */
  border-radius: 7px;
  padding: 5px;

  ::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  :focus, :hover {
    outline: none;
    background-color: #40404080;
  }

  ::-ms-track {
    width: 100%;
    cursor: pointer;

    /* Hides the slider so custom styles can be added */
    background: transparent; 
    border-color: transparent;
    color: transparent;
  }

  // ----------------------------------- apply custom style to thumb ----------------------------------
  /* Special styling for WebKit/Blink */
  ::-webkit-slider-thumb {
    ${thumbStyle}
    margin-top: -6px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
  }

  /* All the same stuff for Firefox */
  ::-moz-range-thumb {
    ${thumbStyle}
  }

  /* All the same stuff for IE */
  ::-ms-thumb {
    ${thumbStyle}
  }

  // ------------------------------ apply custom style to track -----------------------------

  ::-webkit-slider-runnable-track {
    ${trackStyle}
  }

  ::-moz-range-track {
    ${trackStyle}
  }

  ::-ms-track {
    ${trackStyle}
  }
  ::-ms-fill-lower {
    background: #2a6495;
    border: 0.2px solid #010101;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  ::-ms-fill-upper {
    background: #3071a9;
    border: 0.2px solid #010101;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
`

export default Slider;